<template>
    <div class="show-device">
        <div v-if="['Mobile Phone', 'Mobile Device'].includes(device)" class="svg-box" :data-toggle="tooltip ? 'tooltip' : ''" data-placement="bottom" :title="tooltip ? 'Mobile' : ''">
            <inline-svg
                class="main-table__check-icon default s-24"
                src="/images/icons/phone_iphone_black_24dp.svg" aria-label="Mobile">
            </inline-svg>
            <span style="margin-left: 5px;">{{show_name ? 'Mobile' : ''}}</span>
        </div>
        <div v-else-if="['Tablet'].includes(device)" class="svg-box" :data-toggle="tooltip ? 'tooltip' : ''" data-placement="bottom" :title="tooltip ? 'Tablet' : ''">
            <inline-svg
                class="main-table__check-icon default s-24"
                src="/images/icons/tablet_android_black_24dp.svg" aria-label="Tablet">
            </inline-svg>
            <span style="margin-left: 5px;">{{show_name ? 'Tablet' : ''}}</span>
        </div>
        <div v-else-if="['Desktop'].includes(device)" class="svg-box" :data-toggle="tooltip ? 'tooltip' : ''" data-placement="bottom" :title="tooltip ? 'Desktop' : ''">
            <inline-svg
                class="main-table__check-icon default s-24"
                src="/images/icons/desktop_windows_black_24dp.svg" aria-label="Desktop">
            </inline-svg>
            <span style="margin-left: 5px;">{{show_name ? 'Desktop' : ''}}</span>
        </div>
        <div v-else class="svg-box" :data-toggle="tooltip ? 'tooltip' : ''" data-placement="bottom" :title="tooltip ? 'Unknown' : ''">
            <inline-svg
                class="main-table__check-icon default s-24"
                src="/images/icons/phonelink_black_24dp.svg" aria-label="Unknown">
            </inline-svg>
            <span style="margin-left: 5px;">{{show_name ? 'Unknown' : ''}}</span>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['device', 'tooltip', 'show_name']
    }
</script>
